var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoffee = function SvgCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.856 8.698a4.203 4.203 0 1 1 0 8.407h-.301v.3a4.204 4.204 0 0 1-4.203 4.205H6.143a4.205 4.205 0 0 1-4.204-4.204V9.297a.6.6 0 0 1 .6-.6zM3.14 17.406a3.005 3.005 0 0 0 3.004 3.004h7.208a3.005 3.005 0 0 0 3.003-3.004v-7.51H3.14zm14.415-1.501h.301a3.003 3.003 0 0 0 0-6.008h-.301zM6.144 2.39a.6.6 0 0 1 .6.6v2.703a.6.6 0 0 1-1.2 0V2.99a.6.6 0 0 1 .6-.6m3.604 0a.6.6 0 0 1 .6.6v2.703a.6.6 0 0 1-1.2 0V2.99a.6.6 0 0 1 .6-.6m3.604 0a.6.6 0 0 1 .6.6v2.703a.6.6 0 0 1-1.2 0V2.99a.6.6 0 0 1 .6-.6"
  })));
};
export default SvgCoffee;